import React, { useEffect } from 'react'
import { DateInput, GeneralInput, UnitInput } from '../../../../components';
import { IStepFields } from '../../../../interface/MedicalRecord';
import { PregnancyCalculate } from '../../../../utils/PregnancyCalculate';
import { useFormContext } from 'react-hook-form';
import { t } from 'i18next';
import { MedicalKeys } from '../../../../enums/MedicalReportEnums';
import moment from 'moment';

const PregnancyInputs = ({ field, disabled }: {
    field: IStepFields,
    disabled?: boolean;
}) => {

    const methods = useFormContext();
    const customStyleClassName =
        "w-full !h-[50px] !border !border-body-text !bg-white placeholder:!text-text-muted";

    const fieldName = `Attributes.${String(field?.Id)}`;





    const lmpValue = methods.watch(fieldName);
    const GestationalAge = field?.InverseParentStepFields?.find((item) => item?.Key === MedicalKeys.GestationalAge)
    const GestationalAgeName = `Attributes.${String(GestationalAge?.Id)}`

    const EDD = field?.InverseParentStepFields?.find((item) => item?.Key === MedicalKeys.EDD)
    const EddName = `Attributes.${String(EDD?.Id)}`

    const { weeks, estimatedDueDate } = PregnancyCalculate(lmpValue)

    const today = moment().startOf("day");

    const minLmpDate = today
        .clone()
        .subtract(42, "weeks")
        .toDate();

    const maxLmpDate = today.toDate();


    useEffect(() => {

        methods.setValue(GestationalAgeName, weeks)
        methods.setValue(EddName, estimatedDueDate)

    }, [lmpValue])

    return (
        <div className='flex flex-col gap-4'>
            <DateInput
                readOnly={disabled}
                label={field?.Name}
                name={fieldName}
                minDate={minLmpDate}
                maxDate={maxLmpDate}
                className={`medical-date ${customStyleClassName}`}
            />

            {lmpValue && <>
                <UnitInput
                    customStyleClasses={customStyleClassName}
                    type={t("week")}
                    name={GestationalAgeName}
                    placeholder={t("gestational_age")}
                    label={t("gestational_age")}
                    readOnly
                // value={Number(weeks) ?? 0}
                />
                <DateInput
                    readOnly
                    value={estimatedDueDate}
                    label={t("edd")}
                    dateConstraint="future"
                    name={EddName}
                    className={`medical-date ${customStyleClassName}`}
                />

            </>}


        </div>
    )
}

export default PregnancyInputs